/// <amd-module name="Repos/ContentPreview/Html/Components/HtmlPreview" />
import * as React from "react";
import * as ReactDOM from "react-dom";
import { HtmlNormalizer } from "VSS/Features/Markdown/Utils/HtmlNormalizer";
import { VssComponent } from "VSS/Platform/Layout";

interface IHtmlPreviewProps {
    context: { content?: string };
}

class HtmlPreview extends VssComponent<IHtmlPreviewProps> {
    private body: HTMLElement | null;

    public render(): JSX.Element {
        const { context = {} } = this.props;
        const sanitizedContent = HtmlNormalizer.normalizeStripAttributes(context.content || "", undefined, undefined, undefined, undefined, false, [
            "DATA"
        ]);

        if (navigator.userAgent.toLowerCase().indexOf("trident") >= 0) {
            // Internet Explorer does not have srcDoc support. Use a more complicated way of injecting content, and set
            // height to 100% since IE11 does not support flex grow for iframes
            return (
                <iframe frameBorder={0} className="flex flex-grow" onLoad={this.onLoad} ref={this.setContentRef} style={{ height: "100%" }}>
                    {this.body && this.renderContent(this.body, sanitizedContent)}
                </iframe>
            );
        } else {
            // For modern browsers use a fully-sandboxed iframe with srcDoc content
            return (
                <iframe
                    className="flex flex-grow margin-16"
                    frameBorder={0}
                    sandbox=""
                    srcDoc={sanitizedContent}
                    style={{ backgroundColor: "white" }}
                />
            );
        }
    }

    private renderContent(body: HTMLElement, sanitizedContent: string): JSX.Element {
        const rootElement = <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />;
        return ReactDOM.createPortal(rootElement, body);
    }

    private setContentRef = (element: HTMLIFrameElement): void => {
        if (element && element.contentWindow) {
            this.body = element.contentWindow.document.body;
            this.body.style.padding = "20px";
            this.body.style.margin = "0";
        } else {
            this.body = null;
        }
    };

    private onLoad = (): void => {
        if (this.body) {
            this.forceUpdate();
        }
    };
}

VssComponent.register("ms.vss-code-web.html-preview", HtmlPreview);
